module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-03.c102ccd.webp";